import { render } from "./SignupEmail.vue?vue&type=template&id=485095d1&scoped=true"
import script from "./SignupEmail.vue?vue&type=script&lang=js"
export * from "./SignupEmail.vue?vue&type=script&lang=js"

import "@/assets/css/layout_login.css?vue&type=style&index=0&id=485095d1&scoped=true&lang=css"

import exportComponent from "C:\\DEVER\\meta-buysell.vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-485095d1"]])

export default __exports__